<template>
  <Print />
</template>

<script>
import Print from '../../components/invoice/invoicePrint/print/index.vue'
export default {
  name: 'print',
  components: {
    Print,
  },
}
</script>
